import MDModal from 'components/MDModal';
import React, { useState, useEffect } from 'react';
import "../style.css";
import { useAgencyInfo } from 'context/agency';
import ReactSelect, { components } from 'react-select';
import Icon from 'layouts/super-admin/components/Icon';
import { useUserInfo } from 'context/user';
import { useAvailableBranding } from 'queries/prompts';

function Edit({ openModel, onclosemodel, data, modelfunctionality }) {
  const [agency] = useAgencyInfo();
  const user = useUserInfo()[0];
  const [formData, setFormData] = useState({
    prompt_id: "",
    promptName: '',
    description: '',
    category: null,
    jobRoles: [],
    sectors: [],
    integrations: []
  });

  const [jobRolesList, setJobRolesList] = useState([]);
  const [sectorsList, setSectorsList] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);

  const { data: integrationsList = [] } = useAvailableBranding({
    enabled: !!(agency?._id && user?.user_id),
  });

  useEffect(() => {
    if (agency) {
      if (agency.job_roles) {
        setJobRolesList(agency.job_roles.map(role => ({ value: role._id || role.id, label: role.name })));
      }
      if (agency.sectors) {
        setSectorsList(agency.sectors.map(sector => ({ value: sector._id || sector.id, label: sector.name })));
      }
      if (agency.Categories) {
        setCategoriesList(agency.Categories.map(category => ({
          value: category.id || category._id || category.name,
          label: category.name,
          // every id form a task may hold for this category — older tasks store the
          // subdocument _id, newer ones the generated `id`, backfilled ones the name
          ids: [category.id, category._id, category.name].filter(Boolean).map(String)
        })));
      }
    }
  }, [agency]);

  // A task's stored category is a single string, but existing data can hold a
  // comma-separated list ("Marketing, Reports, Content") and the value may be
  // either the agency category id or its name. Match the first entry only.
  const resolveCategory = (value) => {
    const first = String(value || '').split(',')[0].trim();
    if (!first) return null;
    const match = categoriesList.find(
      c => c.value === first
        || (c.ids || []).includes(first)
        || (c.label || '').toLowerCase() === first.toLowerCase()
    );
    if (match) return match;
    // Not in the agency's Categories list (e.g. the picklist changed). Still show what
    // the task has, as long as it reads like a name rather than a generated id.
    const looksLikeName = /\s/.test(first) || /[A-Z]/.test(first);
    return looksLikeName ? { value: first, label: first } : null;
  };

  useEffect(() => {
    if (data) {
      // Map IDs from data to { value, label } objects for ReactSelect
      const selectedJobRoles = data.job_roles ? jobRolesList.filter(role => data.job_roles.includes(role.value)) : [];
      const selectedSectors = data.sectors ? sectorsList.filter(sector => data.sectors.includes(sector.value)) : [];

      // For integrations, we might need to wait for integrationsList too
      const selectedIntegrations = (data.integrations && integrationsList.length > 0)
        ? integrationsList.filter(int => data.integrations.includes(int.value))
        : [];

      setFormData({
        prompt_id: data._id || data.prompt_id || "",
        promptName: data.title || '',
        description: data.description || data.prompt_value || '',
        category: resolveCategory(data.category),
        jobRoles: selectedJobRoles,
        sectors: selectedSectors,
        integrations: selectedIntegrations
      });
    }
  }, [data, jobRolesList, sectorsList, integrationsList, categoriesList]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleMultiChange = (name) => (selectedOptions) => {
    setFormData({
      ...formData,
      [name]: selectedOptions || []
    });
  };

  const handleSingleChange = (name) => (selectedOption) => {
    setFormData({
      ...formData,
      [name]: selectedOption || null
    });
  };

  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: '10px', height: '16px', width: '16px' }}
          />
          <label style={{ fontSize: '14px', fontWeight: '500', color: '#344767', marginBottom: 0 }}>{props.label}</label>
        </div>
      </components.Option>
    );
  };

  const selectStyles = {
    control: (base) => ({
      ...base,
      padding: '5px',
      borderRadius: '8px',
      borderColor: '#d2d6da',
      '&:hover': {
        borderColor: '#000'
      },
      boxShadow: 'none'
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: '14px',
      color: '#92A5AF'
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#f8f9fa' : 'white',
      color: '#344767',
      '&:active': {
        backgroundColor: '#e9ecef'
      }
    })
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
      prompt_id: formData.prompt_id,
      title: formData.promptName,
      prompt_value: formData.description,
      // store the name: that is the format existing tasks use, and agency category
      // ids are regenerated whenever agency default settings are re-applied
      category: formData.category?.label || '',
      job_roles: formData.jobRoles.map(r => r.value),
      sectors: formData.sectors.map(s => s.value),
      integrations: formData.integrations.map(i => i.value),
      active: data?.active !== undefined ? data.active : false
    };
    modelfunctionality(payload);
  };

  return (
    <div>
      {openModel &&
        <div className="modal-zz-confirm text-left"  >
          <div className="scrollable-modal-content bg-white rounded custom_task_modal" style={{ position: "relative" }}>
            <span className='crossison' onClick={onclosemodel}>X</span>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <p className="modalText" style={{ margin: 0 }}>Edit Task</p>
            </div>

            <div className="roundofaddprompt" style={{ width: '100%', display: 'flex', alignItems: 'flex-start', background: '#F8F9FA', borderRadius: '12px', padding: '15px' }}>
              <div style={{ marginRight: '12px', marginTop: '4px' }}>
                <Icon id={'magicstar'} />
              </div>
              <p style={{ margin: 0, fontSize: '14px', color: '#1A1A1A', fontWeight: '500' }}>
                Refine your task settings below. You can update the title, prompt, and target roles/sectors.
              </p>
            </div>

            <div style={{ marginTop: '20px' }}>
              <h2 className='text-black text-left' style={{ fontSize: '16px', fontWeight: '800', marginBottom: '15px' }}>Edit Task Details</h2>

              <form onSubmit={handleSubmit}>
                <div className='w-100 margin_fix'>
                  <label className='new_dezin_label text-black'>Task Title</label>
                  <input
                    type="text"
                    name='promptName'
                    className='w-100 form-control-agust input_od_addPrompt'
                    style={{
                      padding: '12px',
                      borderRadius: '8px',
                      border: '1px solid #d2d6da',
                      marginTop: '5px'
                    }}
                    value={formData.promptName}
                    onChange={handleChange}
                    placeholder="Enter task title..."
                  />
                </div>

                <div className='w-100 margin_fix' style={{ marginTop: '15px' }}>
                  <label className='new_dezin_label text-black'>Task</label>
                  <textarea
                    rows={6}
                    name='description'
                    className='w-100 form-control-agust input_od_addPrompt'
                    style={{
                      padding: '12px',
                      borderRadius: '8px',
                      border: '1px solid #1A1A1A',
                      marginTop: '5px',
                      resize: 'none'
                    }}
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>

                <div className='w-100 margin_fix' style={{ marginTop: '15px' }}>
                  <label className='new_dezin_label text-black'>Category</label>
                  <ReactSelect
                    options={categoriesList}
                    styles={selectStyles}
                    placeholder="Select category..."
                    isClearable
                    value={formData.category}
                    onChange={handleSingleChange('category')}
                  />
                </div>

                <div className='w-100 margin_fix' style={{ marginTop: '15px' }}>
                  <label className='new_dezin_label text-black'>Job Role</label>
                  <ReactSelect
                    isMulti
                    options={jobRolesList}
                    components={{ Option: CustomOption }}
                    styles={selectStyles}
                    placeholder="Select job roles..."
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    value={formData.jobRoles}
                    onChange={handleMultiChange('jobRoles')}
                  />
                </div>

                <div className='w-100 margin_fix' style={{ marginTop: '15px' }}>
                  <label className='new_dezin_label text-black'>Sector</label>
                  <ReactSelect
                    isMulti
                    options={sectorsList}
                    components={{ Option: CustomOption }}
                    styles={selectStyles}
                    placeholder="Select sector..."
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    value={formData.sectors}
                    onChange={handleMultiChange('sectors')}
                  />
                </div>

                <div className='w-100 margin_fix' style={{ marginTop: '15px' }}>
                  <label className='new_dezin_label text-black'>Integrations</label>
                  <ReactSelect
                    isMulti
                    options={integrationsList}
                    components={{ Option: CustomOption }}
                    styles={selectStyles}
                    placeholder="Select integrations..."
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    value={formData.integrations}
                    onChange={handleMultiChange('integrations')}
                  />
                </div>

                <div className='w-100' style={{ marginTop: '30px' }}>
                  <button type='submit' className='btn-newdezine' style={{ padding: '15px', fontSize: '16px', fontWeight: '600' }}>Update Task</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default Edit;
